import type { DeepPartial } from '@luna/utils-ts';

import { documentsHRFeatureConfig } from './documents/HR';
import { exportHRFeatureConfig } from './export/HR';
import { miscHRFeatureConfig } from './misc/HR';
import { ordersHRFeatureConfig } from './orders/HR';
import { overviewHRFeatureConfig } from './overview/HR';
import { printHRFeatureConfig } from './print/HR';
import { productSettingsHRFeatureConfig } from './productSettings/HR';
import { regularOrdersHRFeatureConfig } from './regularOrders/HR';
import { searchHRFeatureConfig } from './search/HR';
import { statementsHRFeatureConfig } from './statements/HR';
import { tradingConfigHR } from './trading/HR';
import { titleDetailHRConfig } from './titleDetail/HR';
import type { InvestmentsFeatureConfig } from '../types/InvestmentsFeatureConfig';

export const investments: DeepPartial<InvestmentsFeatureConfig> = {
    documents: documentsHRFeatureConfig,
    export: exportHRFeatureConfig,
    misc: miscHRFeatureConfig,
    orders: ordersHRFeatureConfig,
    overview: overviewHRFeatureConfig,
    print: printHRFeatureConfig,
    productSettings: productSettingsHRFeatureConfig,
    regularOrders: regularOrdersHRFeatureConfig,
    search: searchHRFeatureConfig,
    statements: statementsHRFeatureConfig,
    titleDetail: titleDetailHRConfig,
    trading: tradingConfigHR,
};
